import {createFileRoute} from '@tanstack/react-router';
import TournamentsView from '../../../../tournaments/TournamentsView.tsx';

export const Route = createFileRoute('/_app/volleyball/tournaments/$tournament_uid/$page/$subpage')({
    component: RouteComponent,
})

function RouteComponent() {
    return <TournamentsView />
}
